var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnPrivacy = function SvgIcnPrivacy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50.5 50.5",
    style: {
      enableBackground: "new 0 0 50.5 50.5"
    },
    xmlSpace: "preserve",
    fill: "#fff",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.1,13.8c1.2,0,2.3,0.7,2.7,1.7c0.3,0.7,1,1.2,1.8,1.2c0.3,0,0.5-0.1,0.8-0.2c1-0.4,1.4-1.6,1-2.6 c-1.1-2.5-3.6-4-6.3-4c-3.8,0-6.9,3-6.9,6.8v2.7c-2.4,0.3-4.2,2.4-4.2,4.9v11.2c0,1.1,0.9,2,2,2h18.3c1.1,0,2-0.9,2-2V24.3 c0-2.7-2.2-4.9-4.9-4.9h-9.2v-2.7C22.2,15.1,23.5,13.8,25.1,13.8z M32.4,24.3v9.3H18v-9.3c0-0.5,0.4-1,1-1h12.4 C31.9,23.3,32.4,23.7,32.4,24.3z M23.2,28.4c0-1.1,0.9-2,2-2s2,0.9,2,2s-0.9,2-2,2S23.2,29.5,23.2,28.4z M50.5,25.2 c0,5-1.5,9.8-4.3,14c-0.6,0.9-1.8,1.1-2.7,0.5c-0.9-0.6-1.1-1.8-0.5-2.7c2.4-3.5,3.6-7.6,3.6-11.8c0-11.7-9.6-21.3-21.3-21.3 S3.9,13.5,3.9,25.2s9.6,21.3,21.3,21.3c3.9,0,7.7-1.1,11-3.1c0.9-0.6,2.1-0.3,2.7,0.7c0.6,0.9,0.3,2.1-0.7,2.7 c-3.9,2.4-8.4,3.6-13.1,3.6c-6.7,0-13.1-2.6-17.9-7.4S0,32,0,25.2S2.6,12.2,7.4,7.4S18.5,0,25.2,0s13.1,2.6,17.9,7.4 S50.5,18.5,50.5,25.2z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnPrivacy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_privacy.9150189a.svg";
export { ForwardRef as ReactComponent };